<main class="main-dashboard">
  <aside class="sidebar" [ngClass]="sidebarsmaller ? 'sidebarsmaller' : ''">
    <div class="sidebar-header">
      <div class="sidebar-logo">
        <a >
          <img src="assets/logo/logo-white.png" alt="" />
          <img src="assets/logo/logo-small.png" class="d-none" />
        </a>
      </div>
    </div>

    <div class="sidebar-item">
      <!-- Loop over all menus -->
      <ng-container *ngFor="let menu of menuItems">
        <!-- Show only the menu whose name matches current menuFlag -->
        <ul *ngIf="menu.name === menuFlag">
          <!-- Menu Heading -->
          <li class="active-menu">
            <a>
              <span><i [class]="menu.icon"></i></span><span>{{ menu.label }}</span>
            </a>
          </li>
  
          <!-- Submenu List -->
          <li *ngFor="let sub of menu.subMenus" [routerLinkActive]="['active']">
            <a [routerLink]="sub.route">
              <span><i [class]="sub.icon"></i></span>
              <span>{{ sub.label }}</span>
            </a>
          </li>
        </ul>
      </ng-container>
    </div>
  </aside>

  <article class="main-canvas" [ngClass]="sidebarbigger ? 'sidebarbigger' : ''">
    <section class="canvas-container">
      <header class="dashboard-header">
        <div class="header-items">
          <div class="header-title">
            <div class="d-flex align-items-center gap-3">
              <button (click)="openCloseInnerSidebarsmaller()" class="sidebar-closer border-0">
                <img src="assets/svg/arrow.svg" alt="" />
              </button>
              <h4>Dashboard</h4>
            </div>
          </div>
          <div class="header-profile">
            <div class="header-menu">
              <div class="mega-menu-selector">
                <p>
                  <span *ngIf="menuFlag == 'Home'" >Home</span>
                  <span *ngIf="menuFlag == 'Project Management'" >PMO</span>
                  <span *ngIf="menuFlag == 'CRM'" >CRM</span>
                  <span *ngIf="menuFlag == 'HRM'" >HRM</span>
                  <span *ngIf="menuFlag == 'ITM'" >ITSM</span>
                  <span *ngIf="menuFlag == 'Finance'" >Finance</span>
                  <span *ngIf="menuFlag == 'Adminstration'" >Admin</span>
                  <span *ngIf="menuFlag == 'My Approval'" >My Approval</span>
                  <span *ngIf="menuFlag == 'Recruit'" >Recruit</span>
                  <i class="ri-arrow-down-s-line"></i>
                </p>
              </div>
              <div class="mega-menu">
                <div class="row">
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'Home'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(6)">
                            <i class="ri-home-3-line"></i>
                            <span>Home</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'Home'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(6)">
                            <i class="ri-home-3-line"></i>
                            <span>Home</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'Project Management'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(1)">
                            <i class="ri-file-list-line"></i>
                            <span>PMO</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'Project Management'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(1)">
                            <i class="ri-file-list-line"></i>
                            <span>PMO</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'CRM'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(2)">
                            <i class="ri-computer-line"></i>
                            <span>CRM</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'CRM'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(2)">
                            <i class="ri-computer-line"></i>
                            <span>CRM</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'HRM'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(3)">
                            <i class="ri-group-line"></i>
                            <span>HRM</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'HRM'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(3)">
                            <i class="ri-group-line"></i>
                            <span>HRM</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'ITM'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(4)">
                            <i class="ri-code-s-slash-fill"></i>
                            <span>ITSM</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'ITM'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(4)">
                            <i class="ri-code-s-slash-fill"></i>
                            <span>ITSM</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'Adminstration'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(5)">
                            <i class="ri-tools-line"></i>
                            <span>Admin</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'Adminstration'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(5)">
                            <i class="ri-tools-line"></i>
                            <span>Admin</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div *ngIf="menuFlag == 'Finance'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(8)">
                            <i class="ri-bank-fill"></i>
                            <span>Finance</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'Finance'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(8)">
                            <i class="ri-bank-fill"></i>
                            <span>Finance</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4" *ngIf="this.tenantId === 'pragamana'">
                    <div *ngIf="menuFlag == 'Recruit'">
                      <div class="mega-menu-item active">
                        <div class="box">
                          <a (click)="changeMenu(9)">
                           <i class="ri-cast-fill"></i>
                            <span>Recruit</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="menuFlag != 'Recruit'">
                      <div class="mega-menu-item">
                        <div class="box">
                          <a (click)="changeMenu(9)">                                                            
                            <i class="ri-cast-fill"></i>
                            <span>Recruit</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="header-notification">
              <button>
                <span class="notification-counter"></span>
                <i class="ri-notification-line"></i>
              </button>
            </div>
            <div class="header-avtar">
              <div class="avtar-item">
                <p>
                  Welcome, <strong>{{ currentUser.displayName }}!</strong>
                </p>
                <img [src]="retrievedImage" alt="profile_pic" />
                <i class="ri-arrow-down-s-fill"></i>
              </div>
              <div class="avtar-option">
                <ul>
                  <li>
                    <a routerLink="profile/profile-page"><i class="ri-user-line"></i> My Profile</a>
                  </li>
                  <li>
                    <a (click)="changeMenu(7)"><i class="ri-thumb-up-fill"></i> My Approval</a>
                  </li>
                  <li>
                    <a routerLink="logout"><i class="ri-login-box-line"></i> Logout</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      <section class="dashboard-items">
        <router-outlet></router-outlet>
      </section>
    </section>
  </article>
</main>